import getConfig from 'next/config';
import { logInfo } from 'utils/logging';
import {
  ConfiguratorAZs,
  ConfiguratorData,
} from 'context/ConfiguratorContext/ConfiguratorContext.types';

const { publicRuntimeConfig } = getConfig();

const getConfigurationBanner = async (): Promise<
  (ConfiguratorData & ConfiguratorAZs) | null
> => {
  try {
    return await fetch(
      `${publicRuntimeConfig.CONFIGURATOR_URL}?configs=otvety_top_banner,otvety_side_banners,otvety_ai_widget,otvety_auth_variant,otvety_ai_toolkit`,
      {
        method: 'GET',
        credentials: 'include',
      },
    ).then((res) => res.json());
  } catch (error: any) {
    logInfo(error.toString(), true);
    return null;
  }
};

export default getConfigurationBanner;
